/**
 * Centralised MRO crouton New Relic events.
 *
 * P0-only for the release: register, impression, timer complete.
 * Keep this file removable in one shot once the release is stable.
 */
import { FEATURE_NR_CALL_STATUS } from "@checkout-core/constants/FeatureNRCallStatus";
import { NEWRELIC_TABLES } from "@checkout-core/constants/NewRelicTables";
import { getMroFlowNRAttrs } from "@checkout-core/helpers/CartFlowNRAttrs";
import { recordNREvent } from "@checkout-core/newrelic";

const EVENT_TYPE = NEWRELIC_TABLES.MRO_FOOD_CART;

export enum MRO_CROUTON_NR_STATE {
    CROUTON_REGISTER = "CROUTON_REGISTER",
    CROUTON_IMPRESSION = "CROUTON_IMPRESSION",
    CROUTON_TIMER_COMPLETE = "CROUTON_TIMER_COMPLETE",
}

function withMroAttrs(extra?: Record<string, string>): Record<string, string> {
    const attrs = getMroFlowNRAttrs();
    return {
        isMroFlow: attrs.isMroFlow,
        xCartType: attrs.xCartType,
        ...(extra || {}),
    };
}

function recordMroCroutonEvent(
    state: MRO_CROUTON_NR_STATE,
    params: {
        croutonId: string;
        attrs?: Record<string, string>;
        extra?: Record<string, string>;
    },
): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state,
        croutonId: params.croutonId,
        status: FEATURE_NR_CALL_STATUS.SUCCESS,
        ...(params.attrs || {}),
        ...withMroAttrs(params.extra),
    });
}

export function recordMroCroutonRegister(params: {
    croutonId: string;
    priority?: number | string;
    forceRefreshContent?: boolean;
    extra?: Record<string, string>;
}): void {
    recordMroCroutonEvent(MRO_CROUTON_NR_STATE.CROUTON_REGISTER, {
        croutonId: params.croutonId,
        attrs: {
            ...(params.priority != null ? { priority: String(params.priority) } : {}),
            ...(params.forceRefreshContent != null
                ? { forceRefreshContent: String(params.forceRefreshContent) }
                : {}),
        },
        extra: params.extra,
    });
}

export function recordMroCroutonImpression(params: {
    croutonId: string;
    extra?: Record<string, string>;
}): void {
    recordMroCroutonEvent(MRO_CROUTON_NR_STATE.CROUTON_IMPRESSION, {
        croutonId: params.croutonId,
        extra: params.extra,
    });
}

export function recordMroCroutonTimerComplete(params: {
    croutonId: string;
    extra?: Record<string, string>;
}): void {
    recordMroCroutonEvent(MRO_CROUTON_NR_STATE.CROUTON_TIMER_COMPLETE, {
        croutonId: params.croutonId,
        extra: params.extra,
    });
}
